import {
  GET_ADDRESS_BY_ID_REQUEST,
  GET_ADDRESS_BY_ID_SUCCESS,
  GET_ADDRESS_BY_ID_FAILURE,
  LOG_OUT_SUCCESS,
} from '../../constants/ActionTypes'
import { Tab } from '../../constants/ComponentTypes'
import * as errMessages from '../../constants/ErrorMessages';

const initialState = {
  contact: {},
  isLoading: false,
  isSaving: false,
  isSaved: false,
  errorMessage: '',
  message: '',
  error: null,
  isDeleted: false, //whether the current data is a deleted node
};

//バックエンドにアドレスのステータス値はフロントのTab値の定義と違うので、ここで変換します。
const updateAddressStatus = (item) => {
  // この関数は、アドレスのステータス値を変換しますが、実際に機能してるか調査して、消した方が良い
  const backendAddressStatusSilence = 1;
  const backendAddressStatusReacted = 2;
  const backendAddressStatusConverted = 3;
  const backendAddressStatusError = 9;

  if (item.status === backendAddressStatusSilence) {
    return { ...item, status: Tab.SILENT }
  } else if (item.status === backendAddressStatusReacted) {
    return { ...item, status: Tab.REACTED }
  } else if (item.status === backendAddressStatusConverted) {
    return { ...item, status: Tab.CONVERTED }
  } else if (item.status === backendAddressStatusError) {
    return { ...item, status: Tab.ERROR }
  } else {
    return item;
  }
}

export default (state = initialState, action) => {
  //default UI flags
  state = {
    ...state,
    isSaved: false,
    isSaving: false,
    errorMessage: '',
    message: '',
    error: null,
    isDeleted: false,
  }

  switch (action.type) {
    case GET_ADDRESS_BY_ID_REQUEST:
      if (action.payload.contact) {
        //if there happen to be a matching contact in addressbook.contacts
        return {
          ...state,
          isLoading: false,
          contact: action.payload.contact
        }
      } else {
        return {
          ...state,
          contact: {},
          isLoading: state.isDeleted || (state.contact.id !== action.payload.id),
        }
      }
    case GET_ADDRESS_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        contact: updateAddressStatus(action.payload.contact),
      }
    case GET_ADDRESS_BY_ID_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: errMessages.ERR_GET_FAILURE,
      }
    case LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/addressDetail.js